// Componente Monedas.vue
<template>
  <div class="animated fadeIn">
    
    <br>
    <b-row>
      <b-col lg="12">
        <b-card>
          <b-row>
            <b-col lg="6"><b><p>Valores del día {{this.fecha}}</p></b></b-col>
            <b-col lg="6">
              <b-form-group label label-for="filtroProceso">
                <b-form-input
                  id="filtroProceso"
                  type="text"
                  placeholder="Filtrar"
                  v-model="filters[0].value"
                  size="sm"
                ></b-form-input>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col lg="12">
              <div ref="refTable">
                <data-tables
                  ref="refTableData"
                  :data="datamoneda"
                  name="table"
                  class="table-responsive"
                  :current-page.sync="pagina"
                  :table-props="tableProps"
                  :filters="filters"
                  :page-size="10"
                  :pagination-props="{ background: true, pageSizes: [10, 20, 50] }"
                  layout="table"
                  >
                  <el-table-column
                    v-for="title in titles"
                    :min-width="title.minwidth"
                    :prop="title.prop"
                    :label="title.label"
                    :key="title.label"
                    :align="title.align"
                    :formatter="formatter"
                    sortable="custom"
                    name="table"
                    class="table-responsive"
                    >
                  </el-table-column>

                  <!-- <el-table-column label="" min-width="100px" align="center">
                  <template slot-scope="scope">
                    <el-tooltip
                        v-for="button in customButtonsForRow(scope.row)"
                        :key="button.id"
                        :content="button.tooltip"
                        placement="top">
                        <b-button size="sm" variant="primary" type="text" @click="button.handler">
                          <i v-bind:class="button.icon"></i>{{ button.name }}
                        </b-button>
                    </el-tooltip>
                  </template>
                  </el-table-column> -->
                </data-tables>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>  
    </b-row>  

    <b-alert 
      dismissible
      :variant="variant"
      v-model="showAlert"
      >
      <p>{{ mensaje }} </p>
      
    </b-alert>

  </div>

</template>
    
<script>

import { Switch as cSwitch } from "@coreui/vue";
import axios from "axios";
import { tablasMixin } from "@/components/mixins/tablasMixin";
import apiConsultaCliente from "@/components/services/apiConsultaCliente";
import { globalesMixin } from "@/components/mixins/globalesMixin";
import { utilesMixin } from "@/components/mixins/utilesMixin";
import Datepicker from "vuejs-datepicker";
import { es } from "vuejs-datepicker/dist/locale";
import moment from 'moment';
import download from "downloadjs";
import Multiselect from 'vue-multiselect';


export default {
  name: "Monedas",
  mixins: [tablasMixin, globalesMixin, utilesMixin],
  props: {
    cod_asegurado: Number,
    participacion: Number,
    
  },

  data: function() {
    return {
      datamoneda:[],
      datadetmoneda:[],
      busqueda: "",
      pagina: 1,
      paginaAnterior: 1,
      showAlert: false,
      modaldetmoneda: false,
      moneda:'',
      fecha: '',
      
      variant: "",
      mensaje: "",
      tableProps: {
        // summaryMethod: this.totales,
        showSummary: false,
        maxHeight: 400,
      },
      
      titles: [
        {
          prop: "codigo",
          label: "Código",
          align: "left",
          minwidth:'100'
        },
        {
          prop: "descripcion",
          label: "Descripción",
          align: "left",
          minwidth:'200'
        },
        {
          prop: "valor",
          label: "Valor",
          align: "right",
          minwidth:'150'
        }
        
      ],

      filters: [
        {
          value: '',
          filterFn: (row, filter) => {
            return Object.keys(row).some(prop => {
              
              return row[prop].toString().toLowerCase().indexOf(filter.value.toLowerCase()) > -1
            })
            
          }
        }
      ],

    }
  },
  methods: {
    
    customButtonsForRow(row) {
      var botones = new Array();
          
      var obj = new Object();
        obj.tooltip = "Detalle moneda";
        obj.id = 1;
        obj.name=" Detalle";
        obj.icon = "fa fa-search";
        obj.type = "success";
        obj.handler= _ => {
          this.$session.start();
          this.recuperar_detmoneda(row.poliza);
          }
          botones.push(obj);
          
        return botones;
    },        

    formatter(row, column) {
      if ((column.property == "fecha"
              ) && row[column.property]) {
            return this.configurarFechaLat(this.convierteFecha(row[column.property]));
          } else if ((column.property == "MONTOFINIQUITO") && row[column.property]) {
            if (row[column.property] == 0 || row[column.property] == "0") {
              return row[column.property];
            } else {
              return this.$numeral(row[column.property]).format("0,0.00");
            }
          } else {
            return row[column.property];
          }
    },

    recuperar_moneda() {
      this.$Progress.start(); 
      return apiConsultaCliente
        .recuperar_moneda(
          this.$session.get("mail"),
          this.$session.get("usuarioInterno"),
          this.cod_asegurado,
          this.participacion
          )  
          .then(response => {
            response.data = this.keysMinuscula(response.data);
            this.datamoneda = response.data.res;
            console.log(this.datamoneda);

            this.fecha = response.data.args_out.fecha;
            console.log(response.data.args_out.fecha);
            this.$Progress.finish();
          })
          .catch(error => {
            this.mensaje= error;
            this.variant="warning";
            this.showAlert = true;
            this.$Progress.finish();
          });
    },

    recuperar_detmoneda(p_poliza) {
         console.log(p_poliza);
      this.$Progress.start(); 
      return apiConsultaCliente
          .recuperar_detmoneda(
            this.$session.get("mail"),
            this.$session.get("usuarioInterno"),
            this.cod_asegurado,
            this.participacion,
            p_poliza

            )  
            .then(response => {
              this.modaldetmoneda = true;            
              response.data = this.keysMinuscula(response.data);
              this.datadetmoneda = response.data.res;
              this.$Progress.finish();
            })
            .catch(error => {
              this.mensaje= error;
              this.variant="warning";
              this.showAlert = true;
              this.$Progress.finish();
            });
      },


  },


  
  
      
  mounted() {
    // this.pagina = Number(this.$route.query.pagina);
    this.recuperar_moneda();
  },
  watch: {
    pagina: function(nuevo, anterior) {
      this.paginaAnterior = anterior;
    },
    
  }      
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>    
<style>
  .card-header {
      background-color: #00A7D4;
      color: #fff;
  }

  .multiselect__tag {
    background: #20a8d8 !important;
  }
  .multiselect__option--highlight:after {
    background: #20a8d8 !important;
  }

  .multiselect__option--highlight {
    background: #20a8d8 !important;
}
.multiselect__tags {
    border-radius: 0px !important;
    min-height: 70px !important;
}

.el-button {
    background: #00A7D4;
}
</style>